import { Route, Switch } from "react-router-dom";
import UniversalAttributionPage from "@faire/prototype-playground/workspace/ka/universal-attribution";
import { withCompass } from "../../components/compass/withCompass";

const VideoAdSearchPage = withCompass(
  () => import("../../pages/VideoAdSearchPage")
);

export function KoroshAhangarRoutes() {
  return (
    <Switch>
      <Route path="/ka/universal-attribution" component={UniversalAttributionPage} />
      <Route path="/ka/video-ad-search" component={VideoAdSearchPage} />
    </Switch>
  );
}

export const slug = "ka";
